<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <!-- <a class="navbar-brand" href="#">Dashboard</a> -->
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto">

          <li class="nav-item">
            <a class="nav-link text-primary" href="#">
             
            </a>
<!--             <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a> -->
          </li>
<!--           <base-dropdown tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </base-dropdown> -->
          <li class="nav-item">
<!--             <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a> -->
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link text-primary" href="#">
              {{CompanyName}}
            </a>
             <a class="nav-link text-primary" href="#">
              |
            </a>
            <a class="nav-link text-primary" href="#">
              Hi {{ContactPerson}}
            </a>
            <span id="License">

              <!-- <span id="License"> -->
                <!-- {{PricePlan}} -->
              <!-- </span> -->
            </span>
<!--             <a class="nav-link" href="#">
              Account
            </a> -->
          </li>
<!--           <base-dropdown title="Dropdown">
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <div class="divider"></div>
            <a class="dropdown-item" href="#">Separated link</a>
          </base-dropdown> -->

          <!-- Log out -->
          <li class="nav-item">
            <a href="#" class="nav-link" @click="Logout()">
              <i class="nc-icon nc-button-power"></i>
            </a>
          </li>

        </ul>
      </div>
    </div>
  </nav>
</template>
<script>

  import { globalStore } from '../main.js';
  import { db } from '../main.js';

  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false,
        PricePlan: "",
        CompanyName: "",
        ContactPerson: "",
      }
    },
    beforeMount(){
      console.log("Before Mount");
      this.RefreshUserInfo();
    },
    methods: {
      RefreshUserInfo(){

                // Refresh CompanyInfo
                console.log("Refresh Company Info");
                console.log("CompanyId: "+globalStore.AdminId);

                db.collection('Company')
                  .doc(globalStore.AdminId)
                  .get()
                  .then((doc) => {

                    if(doc.exists){

                      console.log("------");
                      console.log("PricePlan: "+doc.data().PricePlan);
                      console.log("ContactPerson: "+doc.data().ContactPerson);
                      console.log("Mobile: "+doc.data().Mobile);
                      console.log("Email: "+doc.data().Email);
                      console.log("Menu: "+doc.data().Menu);
                      console.log("Feedback: "+doc.data().Feedback);
                      console.log("Marketing: "+doc.data().Marketing);
                      console.log("------");

                      globalStore.CompanyName = doc.data().CompanyName;
                      globalStore.PricePlan = doc.data().PricePlan;
                      globalStore.ContactPerson = doc.data().ContactPerson;
                      globalStore.Mobile = doc.data().Mobile;
                      globalStore.Email = doc.data().Email;
                      globalStore.Menu = doc.data().Menu;
                      globalStore.Feedback = doc.data().Feedback;
                      globalStore.Marketing = doc.data().Marketing;

                      globalStore.UserInfo = doc.data();

                      this.CompanyName = globalStore.CompanyName;
                      this.ContactPerson = globalStore.ContactPerson;

                      if(doc.data().PricePlan == "Community"){
                        this.PricePlan = "COMMUNITY";              
                      }

                      if(doc.data().FreeTrialExpiry){

                        var date = doc.data().FreeTrialExpiry;
                        console.log("Expires On: "+date);

                        var a = moment();
                        var b = moment(date);
                        var c = a.diff(b, 'days') // 1
                        console.log("Diff: "+c);
                        this.DaysLeft = -1 * parseInt(c);

                        // --- Is 14 day Free Trial over ---
                        if(this.DaysLeft < 15){
                            this.showMsg = true;
                        }else{

                          // --- Trial is over, check is client has paid or not ---
                          // Check PricePlan value. If the trial is over and client has not paid the value will be "TrialExpired"
                          // If trial is over and client has paid, the value will be "Premium"
                            if(doc.data().PricePlan == 'TrialExpired'){
                              // --- Ask to Upgrade, hide screen ----
                              globalStore.Status = 'TrialExpired';
                              console.log("Status: "+globalStore.Status);
                            }else{
                              this.showMsg = false;
                            }

                        }

                      }

                    }
                  })
                  .catch((e) => {
                    console.log('Error:', (e));
                  });


      },
      Logout() {
        console.log("Logging Out...")
        localStorage.removeItem("AdminId")
        localStorage.removeItem("AdminName")
        localStorage.removeItem("AdminEmail")
        this.$router.push('/login')
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      }
    }
  }

</script>
<style>

  #License{
    /*border: 3px;*/
    border: 2px soild red;
    /*background: red;*/
  }

  .nc-button-power{
    /*color: red;*/
  }

</style>
